module.exports = __webpack_public_path__ + "static/media/meat.3c513fc6.svg";